module.exports = __webpack_public_path__ + "img/marker_six_red1.7f1ec144.png";